import { z } from "zod";
import { ChoiceOptionsSchema, FieldBaseSchema, defineControl } from "./field.js";
// A check box group shows every choice at once, as a radio group does, and any
// number of them can be chosen, as from a multi-selection drop-down. Options,
// but no placeholder. Two to start with, named and valued for their place.
export const checkboxGroup = defineControl({
    key: "checkboxGroup",
    label: "Check box group",
    schema: FieldBaseSchema.extend({
        control: z.literal("checkboxGroup"),
        ...ChoiceOptionsSchema.shape,
    }),
    answer: z.string().array(),
    isClearable: true,
    empty: {
        required: false,
        options: [
            { label: "Option 1", value: "option-1" },
            { label: "Option 2", value: "option-2" },
        ],
    },
});
